/**
 * The Google Fonts catalogue (the families Figma offers), generated from
 * https://fonts.google.com/metadata/fonts — 1950 families.
 *
 * Each entry: [family, category, wght] — category s=sans-serif, r=serif,
 * m=monospace, h=handwriting, d=display; wght is the css2 weight spec
 * ("100..900" for a variable font, "400;700" for static weights, "" = regular
 * only). Used by google-font-loader.ts to load a family the moment the page
 * uses it, and by the theme picker's font list.
 */
export type GoogleFontEntry = readonly [family: string, category: 's' | 'r' | 'm' | 'h' | 'd', weights: string];

export const GOOGLE_FONT_CATALOG: ReadonlyArray<GoogleFontEntry> = [
  ["ABeeZee", "s", ""],
  ["Abel", "s", ""],
  ["Abhaya Libre", "r", "400;500;600;700;800"],
  ["Aboreto", "d", ""],
  ["Abril Fatface", "d", ""],
  ["Abyssinica SIL", "r", ""],
  ["Aclonica", "s", ""],
  ["Acme", "s", ""],
  ["Actor", "s", ""],
  ["Adamina", "r", ""],
  ["ADLaM Display", "d", ""],
  ["Advent Pro", "s", "100..900"],
  ["Afacad", "s", "400..700"],
  ["Afacad Flux", "s", "100..1000"],
  ["Agbalumo", "d", ""],
  ["Agdasima", "s", "400;700"],
  ["Agu Display", "d", ""],
  ["Aguafina Script", "h", ""],
  ["Akatab", "s", "400;500;600;700;800;900"],
  ["Akaya Kanadaka", "d", ""],
  ["Akaya Telivigala", "d", ""],
  ["Akronim", "d", ""],
  ["Akshar", "s", "300..700"],
  ["Akt", "s", "100..900"],
  ["Aladin", "d", ""],
  ["Alan Sans", "s", "300..900"],
  ["Alata", "s", ""],
  ["Alatsi", "s", ""],
  ["Albert Sans", "s", "100..900"],
  ["Aldrich", "s", ""],
  ["Alef", "s", "400;700"],
  ["Alegreya", "r", "400..900"],
  ["Alegreya Sans", "s", "100;300;400;500;700;800;900"],
  ["Alegreya Sans SC", "s", "100;300;400;500;700;800;900"],
  ["Alegreya SC", "r", "400;500;700;800;900"],
  ["Aleo", "r", "100..900"],
  ["Alex Brush", "h", ""],
  ["Alexandria", "s", "100..900"],
  ["Alfa Slab One", "d", ""],
  ["Alice", "r", ""],
  ["Alien Block", "d", ""],
  ["Alike", "r", ""],
  ["Alike Angular", "r", ""],
  ["Alkalami", "r", ""],
  ["Alkatra", "d", "400..700"],
  ["Allan", "d", "400;700"],
  ["Allerta", "s", ""],
  ["Allerta Stencil", "s", ""],
  ["Allison", "h", ""],
  ["Allkin", "d", ""],
  ["Allura", "h", ""],
  ["Almarai", "s", "300;400;700;800"],
  ["Almendra", "r", "400;700"],
  ["Almendra Display", "d", ""],
  ["Almendra SC", "r", ""],
  ["Alumni Sans", "s", "100..900"],
  ["Alumni Sans Collegiate One", "s", ""],
  ["Alumni Sans Inline One", "d", ""],
  ["Alumni Sans Pinstripe", "s", ""],
  ["Alumni Sans SC", "s", "100..900"],
  ["Alyamama", "r", "300..900"],
  ["Amarante", "d", ""],
  ["Amaranth", "s", "400;700"],
  ["Amarna", "s", "100..700"],
  ["Amatic SC", "h", "400;700"],
  ["Amethysta", "r", ""],
  ["Amiko", "s", "400;600;700"],
  ["Amiri", "r", "400;700"],
  ["Amiri Quran", "r", ""],
  ["Amita", "h", "400;700"],
  ["Anaheim", "s", "400..800"],
  ["Ancizar Sans", "s", "100..1000"],
  ["Ancizar Serif", "r", "300..900"],
  ["Andada Pro", "r", "400..840"],
  ["Andika", "s", "400;700"],
  ["Anek Bangla", "s", "100..800"],
  ["Anek Devanagari", "s", "100..800"],
  ["Anek Gujarati", "s", "100..800"],
  ["Anek Gurmukhi", "s", "100..800"],
  ["Anek Kannada", "s", "100..800"],
  ["Anek Latin", "s", "100..800"],
  ["Anek Malayalam", "s", "100..800"],
  ["Anek Odia", "s", "100..800"],
  ["Anek Tamil", "s", "100..800"],
  ["Anek Telugu", "s", "100..800"],
  ["Angkor", "d", ""],
  ["Annapurna SIL", "r", "400;700"],
  ["Annie Use Your Telescope", "h", ""],
  ["Anonymous Pro", "m", "400;700"],
  ["Anta", "s", ""],
  ["Antic", "s", ""],
  ["Antic Didone", "r", ""],
  ["Antic Slab", "r", ""],
  ["Anton", "s", ""],
  ["Anton SC", "s", ""],
  ["Antonio", "s", "100..700"],
  ["Anuphan", "s", "100..700"],
  ["Anybody", "d", "100..900"],
  ["Aoboshi One", "r", ""],
  ["AR One Sans", "s", "400..700"],
  ["Arapey", "r", ""],
  ["Arbutus", "r", ""],
  ["Arbutus Slab", "r", ""],
  ["Architects Daughter", "h", ""],
  ["Archivo", "s", "100..900"],
  ["Archivo Black", "s", ""],
  ["Archivo Narrow", "s", "400..700"],
  ["Are You Serious", "h", ""],
  ["Aref Ruqaa", "r", "400;700"],
  ["Aref Ruqaa Ink", "r", "400;700"],
  ["Arima", "d", "100..700"],
  ["Arimo", "s", "400..700"],
  ["Arizonia", "h", ""],
  ["Armata", "s", ""],
  ["Arsenal", "s", "400;700"],
  ["Arsenal SC", "s", "400;700"],
  ["Artifika", "r", ""],
  ["Arvo", "r", "400;700"],
  ["Arya", "s", "400;700"],
  ["Asap", "s", "100..900"],
  ["Asap Condensed", "s", "200;300;400;500;600;700;800;900"],
  ["Asap Sharp", "s", "100..900"],
  ["Asar", "r", ""],
  ["Asimovian", "s", ""],
  ["Asset", "d", ""],
  ["Assistant", "s", "200..800"],
  ["Asta Sans", "s", "300..800"],
  ["Astloch", "d", "400;700"],
  ["Asul", "r", "400;700"],
  ["Athiti", "s", "200;300;400;500;600;700"],
  ["Atkinson Hyperlegible", "s", "400;700"],
  ["Atkinson Hyperlegible Mono", "s", "200..800"],
  ["Atkinson Hyperlegible Next", "s", "200..800"],
  ["Atma", "d", "300;400;500;600;700"],
  ["Atomic Age", "d", ""],
  ["Aubrey", "d", ""],
  ["Audiowide", "d", ""],
  ["Autour One", "d", ""],
  ["Average", "r", ""],
  ["Average Sans", "s", ""],
  ["Averia Gruesa Libre", "d", ""],
  ["Averia Libre", "d", "300;400;700"],
  ["Averia Sans Libre", "d", "300;400;700"],
  ["Averia Serif Libre", "d", "300;400;700"],
  ["Azeret Mono", "m", "100..900"],
  ["B612", "s", "400;700"],
  ["B612 Mono", "m", "400;700"],
  ["Babylonica", "h", ""],
  ["Bacasime Antique", "r", ""],
  ["Bad Script", "h", ""],
  ["Badeen Display", "d", ""],
  ["Bagel Fat One", "d", ""],
  ["Bahiana", "d", ""],
  ["Bahianita", "d", ""],
  ["Bai Jamjuree", "s", "200;300;400;500;600;700"],
  ["Bakbak One", "d", ""],
  ["Ballet", "h", ""],
  ["Baloo 2", "d", "400..800"],
  ["Baloo Bhai 2", "d", "400..800"],
  ["Baloo Bhaijaan 2", "d", "400..800"],
  ["Baloo Bhaina 2", "d", "400..800"],
  ["Baloo Chettan 2", "d", "400..800"],
  ["Baloo Da 2", "d", "400..800"],
  ["Baloo Paaji 2", "d", "400..800"],
  ["Baloo Tamma 2", "d", "400..800"],
  ["Baloo Tammudu 2", "d", "400..800"],
  ["Baloo Thambi 2", "d", "400..800"],
  ["Balsamiq Sans", "d", "400;700"],
  ["Balthazar", "r", ""],
  ["Bangers", "d", ""],
  ["Barlow", "s", "100;200;300;400;500;600;700;800;900"],
  ["Barlow Condensed", "s", "100;200;300;400;500;600;700;800;900"],
  ["Barlow Semi Condensed", "s", "100;200;300;400;500;600;700;800;900"],
  ["Barriecito", "d", ""],
  ["Barrio", "d", ""],
  ["Basic", "s", ""],
  ["Baskervville", "r", "400..700"],
  ["Baskervville SC", "r", "400..700"],
  ["Battambang", "d", "100;300;400;700;900"],
  ["Baumans", "d", ""],
  ["Bayon", "s", ""],
  ["BBH Bartle", "s", ""],
  ["BBH Bogle", "s", ""],
  ["BBH Hegarty", "s", ""],
  ["Be Vietnam Pro", "s", "100;200;300;400;500;600;700;800;900"],
  ["Beau Rivage", "h", ""],
  ["Bebas Neue", "s", ""],
  ["Beiruti", "s", "200..900"],
  ["Belanosima", "s", "400;600;700"],
  ["Belgrano", "r", ""],
  ["Bellefair", "r", ""],
  ["Belleza", "s", ""],
  ["Bellota", "d", "300;400;700"],
  ["Bellota Text", "d", "300;400;700"],
  ["BenchNine", "s", "300;400;700"],
  ["Benne", "r", ""],
  ["Bentham", "r", ""],
  ["Berkshire Swash", "h", ""],
  ["Besley", "r", "400..900"],
  ["Betania Patmos", "h", ""],
  ["Betania Patmos GDL", "h", ""],
  ["Betania Patmos In", "h", ""],
  ["Betania Patmos In GDL", "h", ""],
  ["Beth Ellen", "h", ""],
  ["Bevan", "r", ""],
  ["BhuTuka Expanded One", "r", ""],
  ["Big Shoulders", "d", "100..900"],
  ["Big Shoulders Inline", "d", "100..900"],
  ["Big Shoulders Stencil", "d", "100..900"],
  ["Bigelow Rules", "d", ""],
  ["Bigshot One", "d", ""],
  ["Bilbo", "h", ""],
  ["Bilbo Swash Caps", "h", ""],
  ["BioRhyme", "r", "200..800"],
  ["BioRhyme Expanded", "r", "200;300;400;700;800"],
  ["Birthstone", "h", ""],
  ["Birthstone Bounce", "h", "400;500"],
  ["Biryani", "s", "200;300;400;600;700;800;900"],
  ["Bitcount", "d", "100..900"],
  ["Bitcount Grid Double", "d", "100..900"],
  ["Bitcount Grid Double Ink", "d", "100..900"],
  ["Bitcount Grid Single", "d", "100..900"],
  ["Bitcount Grid Single Ink", "d", "100..900"],
  ["Bitcount Ink", "d", "100..900"],
  ["Bitcount Prop Double", "d", "100..900"],
  ["Bitcount Prop Double Ink", "d", "100..900"],
  ["Bitcount Prop Single", "d", "100..900"],
  ["Bitcount Prop Single Ink", "d", "100..900"],
  ["Bitcount Single", "d", "100..900"],
  ["Bitcount Single Ink", "d", "100..900"],
  ["Bitter", "r", "100..900"],
  ["BIZ UDGothic", "s", "400;700"],
  ["BIZ UDMincho", "r", "400;700"],
  ["BIZ UDPGothic", "s", "400;700"],
  ["BIZ UDPMincho", "r", "400;700"],
  ["BJCree", "r", "400;500;600;700"],
  ["Black And White Picture", "d", ""],
  ["Black Han Sans", "s", ""],
  ["Black Ops One", "d", ""],
  ["Blaka", "d", ""],
  ["Blaka Hollow", "d", ""],
  ["Blaka Ink", "d", ""],
  ["Blinker", "s", "100;200;300;400;600;700;800;900"],
  ["Bodoni Moda", "r", "400..900"],
  ["Bodoni Moda SC", "r", "400..900"],
  ["Bokor", "d", ""],
  ["Boldonse", "d", ""],
  ["Bona Nova", "r", "400;700"],
  ["Bona Nova SC", "r", "400;700"],
  ["Bonbon", "h", ""],
  ["Bonheur Royale", "h", ""],
  ["Boogaloo", "d", ""],
  ["Borel", "h", ""],
  ["Bowlby One", "d", ""],
  ["Bowlby One SC", "d", ""],
  ["Bpmf Huninn", "s", ""],
  ["Bpmf Iansui", "h", ""],
  ["Bpmf Zihi Kai Std", "s", ""],
  ["Braah One", "s", ""],
  ["Brawler", "r", "400;700"],
  ["Bree Serif", "r", ""],
  ["Bricolage Grotesque", "s", "200..800"],
  ["Bruno Ace", "d", ""],
  ["Bruno Ace SC", "d", ""],
  ["Brygada 1918", "r", "400..700"],
  ["Bubblegum Sans", "d", ""],
  ["Bubbler One", "s", ""],
  ["Buda", "d", "300"],
  ["Buenard", "r", "400..700"],
  ["Bungee", "d", ""],
  ["Bungee Hairline", "d", ""],
  ["Bungee Inline", "d", ""],
  ["Bungee Outline", "d", ""],
  ["Bungee Shade", "d", ""],
  ["Bungee Spice", "d", ""],
  ["Bungee Tint", "d", ""],
  ["Butcherman", "d", ""],
  ["Butterfly Kids", "h", ""],
  ["Bytesized", "s", ""],
  ["Caacupe One", "d", ""],
  ["Cabin", "s", "400..700"],
  ["Cabin Condensed", "s", "400;500;600;700"],
  ["Cabin Sketch", "d", "400;700"],
  ["Cactus Classical Serif", "r", ""],
  ["Caesar Dressing", "d", ""],
  ["Cagliostro", "s", ""],
  ["Cairo", "s", "200..1000"],
  ["Cairo Play", "s", "200..1000"],
  ["Cal Sans", "s", ""],
  ["Caladea", "r", "400;700"],
  ["Calistoga", "d", ""],
  ["Calligraffitti", "h", ""],
  ["Cambay", "s", "400;700"],
  ["Cambo", "r", ""],
  ["Candal", "s", ""],
  ["Cantarell", "s", "400;700"],
  ["Cantata One", "r", ""],
  ["Cantora One", "s", ""],
  ["Caprasimo", "d", ""],
  ["Capriola", "s", ""],
  ["Caramel", "h", ""],
  ["Carattere", "h", ""],
  ["Cardo", "r", "400;700"],
  ["Carlito", "s", "400;700"],
  ["Carme", "s", ""],
  ["Carrois Gothic", "s", ""],
  ["Carrois Gothic SC", "s", ""],
  ["Carter One", "d", ""],
  ["Cascadia Code", "s", "200..700"],
  ["Cascadia Mono", "s", "200..700"],
  ["Castoro", "r", ""],
  ["Castoro Titling", "d", ""],
  ["Catamaran", "s", "100..900"],
  ["Caudex", "r", "400;700"],
  ["Cause", "h", "100..900"],
  ["Caveat", "h", "400..700"],
  ["Caveat Brush", "h", ""],
  ["Cedarville Cursive", "h", ""],
  ["Ceviche One", "d", ""],
  ["Chakra Petch", "s", "300;400;500;600;700"],
  ["Changa", "s", "200..800"],
  ["Changa One", "d", ""],
  ["Chango", "d", ""],
  ["Charis SIL", "r", "400;700"],
  ["Charm", "h", "400;700"],
  ["Charmonman", "h", "400;700"],
  ["Chathura", "s", "100;300;400;700;800"],
  ["Chau Philomene One", "s", ""],
  ["Chela One", "d", ""],
  ["Chelsea Market", "d", ""],
  ["Chenla", "d", ""],
  ["Cherish", "h", ""],
  ["Cherry Bomb One", "d", ""],
  ["Cherry Cream Soda", "d", ""],
  ["Cherry Swash", "d", "400;700"],
  ["Chewy", "d", ""],
  ["Chicle", "d", ""],
  ["Chilanka", "h", ""],
  ["Chiron GoRound TC", "s", "200..900"],
  ["Chiron Hei HK", "s", "200..900"],
  ["Chiron Sung HK", "r", "200..900"],
  ["Chivo", "s", "100..900"],
  ["Chivo Mono", "m", "100..900"],
  ["Chocolate Classical Sans", "s", ""],
  ["Chokokutai", "d", ""],
  ["Chonburi", "d", ""],
  ["Cinzel", "r", "400..900"],
  ["Cinzel Decorative", "d", "400;700;900"],
  ["Clarity City", "s", "100..900"],
  ["Clicker Script", "h", ""],
  ["Climate Crisis", "d", ""],
  ["Coda", "d", "400;800"],
  ["Codystar", "d", "300;400"],
  ["Coiny", "d", ""],
  ["Combo", "d", ""],
  ["Comfortaa", "d", "300..700"],
  ["Comforter", "h", ""],
  ["Comforter Brush", "h", ""],
  ["Comic Neue", "h", "300;400;700"],
  ["Comic Relief", "d", "400;700"],
  ["Coming Soon", "h", ""],
  ["Comme", "s", "100..900"],
  ["Commissioner", "s", "100..900"],
  ["Concert One", "d", ""],
  ["Condiment", "h", ""],
  ["Content", "d", "400;700"],
  ["Contrail One", "d", ""],
  ["Convergence", "s", ""],
  ["Cookie", "h", ""],
  ["Copse", "r", ""],
  ["Coral Pixels", "d", ""],
  ["Corben", "d", "400;700"],
  ["Corinthia", "h", "400;700"],
  ["Cormorant", "r", "300..700"],
  ["Cormorant Garamond", "r", "300..700"],
  ["Cormorant Infant", "r", "300..700"],
  ["Cormorant SC", "r", "300;400;500;600;700"],
  ["Cormorant Unicase", "r", "300;400;500;600;700"],
  ["Cormorant Upright", "r", "300;400;500;600;700"],
  ["Cossette Texte", "s", "400;700"],
  ["Cossette Titre", "s", "400;700"],
  ["Courgette", "h", ""],
  ["Courier Prime", "m", "400;700"],
  ["Cousine", "m", "400;700"],
  ["Coustard", "r", "400;900"],
  ["Covered By Your Grace", "h", ""],
  ["Crafty Girls", "h", ""],
  ["Creepster", "d", ""],
  ["Crete Round", "r", ""],
  ["Crimson Pro", "r", "200..900"],
  ["Crimson Text", "r", "400;600;700"],
  ["Croissant One", "d", ""],
  ["Crushed", "d", ""],
  ["Cuprum", "s", "400..700"],
  ["Cute Font", "d", ""],
  ["Cutive", "r", ""],
  ["Cutive Mono", "m", ""],
  ["Dai Banna SIL", "r", "300;400;500;600;700"],
  ["Damion", "h", ""],
  ["Dancing Script", "h", "400..700"],
  ["Danfo", "r", ""],
  ["Dangrek", "d", ""],
  ["Darker Grotesque", "s", "300..900"],
  ["Darumadrop One", "d", ""],
  ["Datatype", "m", "100..900"],
  ["David Libre", "r", "400;500;700"],
  ["Dawning of a New Day", "h", ""],
  ["Days One", "s", ""],
  ["Dekko", "h", ""],
  ["Dela Gothic One", "d", ""],
  ["Delicious Handrawn", "h", ""],
  ["Delius", "h", ""],
  ["Delius Swash Caps", "h", ""],
  ["Delius Unicase", "h", "400;700"],
  ["Della Respira", "r", ""],
  ["Denk One", "s", ""],
  ["Devonshire", "h", ""],
  ["Dhurjati", "s", ""],
  ["Didact Gothic", "s", ""],
  ["Diphylleia", "r", ""],
  ["Diplomata", "d", ""],
  ["Diplomata SC", "d", ""],
  ["DM Mono", "m", "300;400;500"],
  ["DM Sans", "s", "100..1000"],
  ["DM Serif Display", "r", ""],
  ["DM Serif Text", "r", ""],
  ["Do Hyeon", "s", ""],
  ["Dokdo", "d", ""],
  ["Domine", "r", "400..700"],
  ["Donegal One", "r", ""],
  ["Dongle", "s", "300;400;700"],
  ["Doppio One", "s", ""],
  ["Dorsa", "s", ""],
  ["Dosis", "s", "200..800"],
  ["DotGothic16", "s", ""],
  ["Doto", "s", "100..900"],
  ["Dr Sugiyama", "h", ""],
  ["Duru Sans", "s", ""],
  ["Dynalight", "d", ""],
  ["DynaPuff", "d", "400..700"],
  ["Eagle Lake", "h", ""],
  ["East Sea Dokdo", "h", ""],
  ["Eater", "d", ""],
  ["EB Garamond", "r", "400..800"],
  ["Economica", "s", "400;700"],
  ["Eczar", "r", "400..800"],
  ["Edu AU VIC WA NT Arrows", "h", "400..700"],
  ["Edu AU VIC WA NT Dots", "h", "400..700"],
  ["Edu AU VIC WA NT Guides", "h", "400..700"],
  ["Edu AU VIC WA NT Hand", "h", "400..700"],
  ["Edu AU VIC WA NT Pre", "h", "400..700"],
  ["Edu NSW ACT Cursive", "h", "400..700"],
  ["Edu NSW ACT Foundation", "h", "400..700"],
  ["Edu NSW ACT Hand Pre", "h", "400..700"],
  ["Edu QLD Beginner", "h", "400..700"],
  ["Edu QLD Hand", "h", "400..700"],
  ["Edu SA Beginner", "h", "400..700"],
  ["Edu SA Hand", "h", "400..700"],
  ["Edu TAS Beginner", "h", "400..700"],
  ["Edu VIC WA NT Beginner", "h", "400..700"],
  ["Edu VIC WA NT Hand", "h", "400..700"],
  ["Edu VIC WA NT Hand Pre", "h", "400..700"],
  ["El Messiri", "s", "400..700"],
  ["Electrolize", "s", ""],
  ["Elms Sans", "s", "100..900"],
  ["Elsie", "d", "400;900"],
  ["Elsie Swash Caps", "d", "400;900"],
  ["Emblema One", "d", ""],
  ["Emilys Candy", "d", ""],
  ["Encode Sans", "s", "100..900"],
  ["Encode Sans Condensed", "s", "100;200;300;400;500;600;700;800;900"],
  ["Encode Sans Expanded", "s", "100;200;300;400;500;600;700;800;900"],
  ["Encode Sans SC", "s", "100..900"],
  ["Encode Sans Semi Condensed", "s", "100;200;300;400;500;600;700;800;900"],
  ["Encode Sans Semi Expanded", "s", "100;200;300;400;500;600;700;800;900"],
  ["Engagement", "h", ""],
  ["Englebert", "s", ""],
  ["Enriqueta", "r", "400;500;600;700"],
  ["Ephesis", "h", ""],
  ["Epilogue", "s", "100..900"],
  ["Epunda Sans", "s", "300..900"],
  ["Epunda Slab", "r", "300..900"],
  ["Erica One", "d", ""],
  ["Esteban", "r", ""],
  ["Estedad", "s", "100..900"],
  ["Estonia", "h", ""],
  ["Euphoria Script", "h", ""],
  ["Ewert", "d", ""],
  ["Exile", "d", ""],
  ["Exo", "s", "100..900"],
  ["Exo 2", "s", "100..900"],
  ["Expletus Sans", "d", "400..700"],
  ["Explora", "h", ""],
  ["Faculty Glyphic", "s", ""],
  ["Fahkwang", "s", "200;300;400;500;600;700"],
  ["Familjen Grotesk", "s", "400..700"],
  ["Fanwood Text", "r", ""],
  ["Farro", "s", "300;400;500;700"],
  ["Farsan", "d", ""],
  ["Fascinate", "d", ""],
  ["Fascinate Inline", "d", ""],
  ["Faster One", "d", ""],
  ["Fasthand", "d", ""],
  ["Fauna One", "r", ""],
  ["Faustina", "r", "300..800"],
  ["Federant", "d", ""],
  ["Federo", "s", ""],
  ["Felipa", "h", ""],
  ["Fenix", "r", ""],
  ["Festive", "h", ""],
  ["Figtree", "s", "300..900"],
  ["Finger Paint", "d", ""],
  ["Finlandica Headline", "s", "100..900"],
  ["Finlandica Text", "s", "100..900"],
  ["Fira Code", "m", "300..700"],
  ["Fira Mono", "m", "400;500;700"],
  ["Fira Sans", "s", "100;200;300;400;500;600;700;800;900"],
  ["Fira Sans Condensed", "s", "100;200;300;400;500;600;700;800;900"],
  ["Fira Sans Extra Condensed", "s", "100;200;300;400;500;600;700;800;900"],
  ["Fjalla One", "s", ""],
  ["Fjord One", "r", ""],
  ["Flamenco", "d", "300;400"],
  ["Flavors", "d", ""],
  ["Fleur De Leah", "h", ""],
  ["Flow Block", "d", ""],
  ["Flow Circular", "d", ""],
  ["Flow Rounded", "d", ""],
  ["Foldit", "d", "100..900"],
  ["Fondamento", "h", ""],
  ["Fontdiner Swanky", "d", ""],
  ["Forum", "d", ""],
  ["Fragment Mono", "m", ""],
  ["Francois One", "s", ""],
  ["Frank Ruhl Libre", "r", "300..900"],
  ["Fraunces", "r", "100..900"],
  ["Freckle Face", "d", ""],
  ["Fredericka the Great", "d", ""],
  ["Fredoka", "s", "300..700"],
  ["Freehand", "d", ""],
  ["Freeman", "d", ""],
  ["Fresca", "s", ""],
  ["Frijole", "d", ""],
  ["Fruktur", "d", ""],
  ["Fugaz One", "d", ""],
  ["Fuggles", "h", ""],
  ["Funnel Display", "d", "300..800"],
  ["Funnel Sans", "s", "300..800"],
  ["Fustat", "s", "200..800"],
  ["Fuzzy Bubbles", "h", "400;700"],
  ["Ga Maamli", "d", ""],
  ["Gabarito", "d", "400..900"],
  ["Gabriela", "r", ""],
  ["Gaegu", "h", "300;400;700"],
  ["Gafata", "s", ""],
  ["Gajraj One", "d", ""],
  ["Galada", "d", ""],
  ["Galdeano", "s", ""],
  ["Galindo", "d", ""],
  ["Gamja Flower", "h", ""],
  ["Gantari", "s", "100..900"],
  ["Gasoek One", "s", ""],
  ["Gayathri", "s", "100;400;700"],
  ["Geist", "s", "100..900"],
  ["Geist Mono", "m", "100..900"],
  ["Geist Pixel", "d", ""],
  ["Gelasio", "r", "400..700"],
  ["Gemunu Libre", "s", "200..800"],
  ["Genos", "s", "100..900"],
  ["Gentium Book Plus", "r", "400;700"],
  ["Gentium Plus", "r", "400;700"],
  ["Geo", "s", ""],
  ["Geologica", "s", "100..900"],
  ["Geom", "s", "300..900"],
  ["Geomini", "s", "200..800"],
  ["Georama", "s", "100..900"],
  ["Geostar", "d", ""],
  ["Geostar Fill", "d", ""],
  ["Germania One", "d", ""],
  ["GFS Didot", "r", ""],
  ["GFS Neohellenic", "s", "400;700"],
  ["Gideon Roman", "d", ""],
  ["Gidole", "s", ""],
  ["Gidugu", "s", ""],
  ["Gilda Display", "r", ""],
  ["Girassol", "d", ""],
  ["Give You Glory", "h", ""],
  ["Glass Antiqua", "d", ""],
  ["Glegoo", "r", "400;700"],
  ["Gloock", "r", ""],
  ["Gloria Hallelujah", "h", ""],
  ["Glory", "s", "100..800"],
  ["Gluten", "d", "100..900"],
  ["Goblin One", "d", ""],
  ["Gochi Hand", "h", ""],
  ["Goldman", "d", "400;700"],
  ["Golos Text", "s", "400..900"],
  ["Google Sans", "s", "400..700"],
  ["Google Sans Code", "m", "300..800"],
  ["Google Sans Flex", "s", "1..1000"],
  ["Gorditas", "d", "400;700"],
  ["Gothic A1", "s", "100;200;300;400;500;600;700;800;900"],
  ["Gotu", "s", ""],
  ["Goudy Bookletter 1911", "r", ""],
  ["Gowun Batang", "r", "400;700"],
  ["Gowun Dodum", "s", ""],
  ["Graduate", "r", ""],
  ["Grand Hotel", "h", ""],
  ["Grandiflora One", "r", ""],
  ["Grandstander", "d", "100..900"],
  ["Grape Nuts", "h", ""],
  ["Gravitas One", "d", ""],
  ["Great Vibes", "h", ""],
  ["Grechen Fuemen", "h", ""],
  ["Grenze", "r", "100..900"],
  ["Grenze Gotisch", "d", "100..900"],
  ["Grey Qo", "h", ""],
  ["Griffy", "d", ""],
  ["Gruppo", "s", ""],
  ["Gudea", "s", "400;700"],
  ["Gugi", "d", ""],
  ["Gulzar", "r", ""],
  ["Gupter", "r", "400;500;700"],
  ["Gurajada", "s", ""],
  ["Gveret Levin", "h", ""],
  ["Gwendolyn", "h", "400;700"],
  ["Habibi", "r", ""],
  ["Hachi Maru Pop", "h", ""],
  ["Hahmlet", "r", "100..900"],
  ["Halant", "r", "300;400;500;600;700"],
  ["Hammersmith One", "s", ""],
  ["Hanalei", "d", ""],
  ["Hanalei Fill", "d", ""],
  ["Handjet", "d", "100..900"],
  ["Handlee", "h", ""],
  ["Hanken Grotesk", "s", "100..900"],
  ["Hanuman", "r", "100..900"],
  ["Happy Monkey", "d", ""],
  ["Harmattan", "s", "400;500;600;700"],
  ["Headland One", "r", ""],
  ["Hedvig Letters Sans", "s", ""],
  ["Hedvig Letters Serif", "r", ""],
  ["Heebo", "s", "100..900"],
  ["Henny Penny", "d", ""],
  ["Hepta Slab", "r", "1..900"],
  ["Herr Von Muellerhoff", "h", ""],
  ["Hi Melody", "h", ""],
  ["Hibur Mono", "m", ""],
  ["Hina Mincho", "r", ""],
  ["Hind", "s", "300;400;500;600;700"],
  ["Hind Guntur", "s", "300;400;500;600;700"],
  ["Hind Madurai", "s", "300;400;500;600;700"],
  ["Hind Mysuru", "s", "300;400;500;600;700"],
  ["Hind Siliguri", "s", "300;400;500;600;700"],
  ["Hind Vadodara", "s", "300;400;500;600;700"],
  ["Holtwood One SC", "r", ""],
  ["Homemade Apple", "h", ""],
  ["Homenaje", "s", ""],
  ["Honk", "d", ""],
  ["Host Grotesk", "s", "300..800"],
  ["Hubballi", "s", ""],
  ["Hubot Sans", "s", "200..900"],
  ["Huninn", "s", ""],
  ["Hurricane", "h", ""],
  ["Iansui", "h", ""],
  ["Ibarra Real Nova", "r", "400..700"],
  ["IBM Plex Mono", "m", "100;200;300;400;500;600;700"],
  ["IBM Plex Sans", "s", "100..700"],
  ["IBM Plex Sans Arabic", "s", "100;200;300;400;500;600;700"],
  ["IBM Plex Sans Condensed", "s", "100;200;300;400;500;600;700"],
  ["IBM Plex Sans Devanagari", "s", "100;200;300;400;500;600;700"],
  ["IBM Plex Sans Hebrew", "s", "100;200;300;400;500;600;700"],
  ["IBM Plex Sans JP", "s", "100;200;300;400;500;600;700"],
  ["IBM Plex Sans KR", "s", "100;200;300;400;500;600;700"],
  ["IBM Plex Sans Thai", "s", "100;200;300;400;500;600;700"],
  ["IBM Plex Sans Thai Looped", "s", "100;200;300;400;500;600;700"],
  ["IBM Plex Serif", "r", "100;200;300;400;500;600;700"],
  ["Iceberg", "d", ""],
  ["Iceland", "d", ""],
  ["Idiqlat", "r", "200;300;400"],
  ["IM Fell Double Pica", "r", ""],
  ["IM Fell Double Pica SC", "r", ""],
  ["IM Fell DW Pica", "r", ""],
  ["IM Fell DW Pica SC", "r", ""],
  ["IM Fell English", "r", ""],
  ["IM Fell English SC", "r", ""],
  ["IM Fell French Canon", "r", ""],
  ["IM Fell French Canon SC", "r", ""],
  ["IM Fell Great Primer", "r", ""],
  ["IM Fell Great Primer SC", "r", ""],
  ["Imbue", "r", "100..900"],
  ["Imperial Script", "h", ""],
  ["Imprima", "s", ""],
  ["Inclusive Sans", "s", "300..700"],
  ["Inconsolata", "m", "200..900"],
  ["Inder", "s", ""],
  ["Indie Flower", "h", ""],
  ["Ingrid Darling", "h", ""],
  ["Inika", "r", "400;700"],
  ["Inknut Antiqua", "r", "300;400;500;600;700;800;900"],
  ["Inria Sans", "s", "300;400;700"],
  ["Inria Serif", "r", "300;400;700"],
  ["Inspiration", "h", ""],
  ["Instrument Sans", "s", "400..700"],
  ["Instrument Serif", "r", ""],
  ["Intel One Mono", "m", "300..700"],
  ["Inter", "s", "100..900"],
  ["Inter Tight", "s", "100..900"],
  ["Iosevka Charon", "m", "300;400;500;700"],
  ["Iosevka Charon Mono", "m", "300;400;500;700"],
  ["Irish Grover", "d", ""],
  ["Island Moments", "h", ""],
  ["Isometra", "r", ""],
  ["Istok Web", "s", "400;700"],
  ["Italiana", "s", ""],
  ["Italianno", "h", ""],
  ["Itim", "h", ""],
  ["Jacquard 12", "d", ""],
  ["Jacquard 12 Charted", "d", ""],
  ["Jacquard 24", "d", ""],
  ["Jacquard 24 Charted", "d", ""],
  ["Jacquarda Bastarda 9", "d", ""],
  ["Jacquarda Bastarda 9 Charted", "d", ""],
  ["Jacques Francois", "r", ""],
  ["Jacques Francois Shadow", "d", ""],
  ["Jaini", "d", ""],
  ["Jaini Purva", "d", ""],
  ["Jaldi", "s", "400;700"],
  ["Jaro", "s", ""],
  ["Jersey 10", "d", ""],
  ["Jersey 10 Charted", "d", ""],
  ["Jersey 15", "d", ""],
  ["Jersey 15 Charted", "d", ""],
  ["Jersey 20", "d", ""],
  ["Jersey 20 Charted", "d", ""],
  ["Jersey 25", "d", ""],
  ["Jersey 25 Charted", "d", ""],
  ["JetBrains Mono", "m", "100..800"],
  ["Jim Nightshade", "h", ""],
  ["Joan", "r", ""],
  ["Jockey One", "s", ""],
  ["Jolly Lodger", "d", ""],
  ["Jomhuria", "d", ""],
  ["Jomolhari", "r", ""],
  ["Josefin Sans", "s", "100..700"],
  ["Josefin Slab", "r", "100..700"],
  ["Jost", "s", "100..900"],
  ["Joti One", "d", ""],
  ["Jua", "s", ""],
  ["Judson", "r", "400;700"],
  ["Julee", "h", ""],
  ["Julius Sans One", "s", ""],
  ["Junge", "r", ""],
  ["Jura", "s", "300..700"],
  ["Just Another Hand", "h", ""],
  ["Just Me Again Down Here", "h", ""],
  ["K2D", "s", "100;200;300;400;500;600;700;800"],
  ["Kablammo", "d", ""],
  ["Kadwa", "r", "400;700"],
  ["Kaisei Decol", "r", "400;500;700"],
  ["Kaisei HarunoUmi", "r", "400;500;700"],
  ["Kaisei Opti", "r", "400;500;700"],
  ["Kaisei Tokumin", "r", "400;500;700;800"],
  ["Kalam", "h", "300;400;700"],
  ["Kalnia", "r", "100..700"],
  ["Kalnia Glaze", "d", "100..700"],
  ["Kameron", "r", "400..700"],
  ["Kanchenjunga", "s", "400;500;600;700"],
  ["Kanit", "s", "100;200;300;400;500;600;700;800;900"],
  ["Kantumruy Pro", "s", "100..700"],
  ["Kapakana", "h", "300..400"],
  ["Karantina", "d", "300;400;700"],
  ["Karla", "s", "200..800"],
  ["Karla Tamil Inclined", "s", "400;700"],
  ["Karla Tamil Upright", "s", "400;700"],
  ["Karma", "r", "300;400;500;600;700"],
  ["Katibeh", "d", ""],
  ["Kaushan Script", "h", ""],
  ["Kavivanar", "h", ""],
  ["Kavoon", "d", ""],
  ["Kay Pho Du", "r", "400;500;600;700"],
  ["Kdam Thmor Pro", "s", ""],
  ["Keania One", "d", ""],
  ["Kedebideri", "s", "400;500;600;700;800;900"],
  ["Kelly Slab", "d", ""],
  ["Kenia", "d", ""],
  ["Khand", "s", "300;400;500;600;700"],
  ["Khmer", "s", ""],
  ["Khula", "s", "300;400;600;700;800"],
  ["Kings", "h", ""],
  ["Kirang Haerang", "d", ""],
  ["Kite One", "s", ""],
  ["Kiwi Maru", "r", "300;400;500"],
  ["Klee One", "h", "400;600"],
  ["Knewave", "d", ""],
  ["Kodchasan", "s", "200;300;400;500;600;700"],
  ["Kode Mono", "m", "400..700"],
  ["Koh Santepheap", "r", "100;300;400;700;900"],
  ["KoHo", "s", "200;300;400;500;600;700"],
  ["Kolker Brush", "h", ""],
  ["Konkhmer Sleokchher", "d", ""],
  ["Kosugi", "s", ""],
  ["Kosugi Maru", "s", ""],
  ["Kotta One", "r", ""],
  ["Koulen", "d", ""],
  ["Kranky", "d", ""],
  ["Kreon", "r", "300..700"],
  ["Kripa", "s", "100..900"],
  ["Kristi", "h", ""],
  ["Krona One", "s", ""],
  ["Krub", "s", "200;300;400;500;600;700"],
  ["Kufam", "s", "400..900"],
  ["Kulim Park", "s", "200;300;400;600;700"],
  ["Kumar One", "d", ""],
  ["Kumar One Outline", "d", ""],
  ["Kumbh Sans", "s", "100..900"],
  ["Kurale", "r", ""],
  ["La Belle Aurore", "h", ""],
  ["Labrada", "r", "100..900"],
  ["Lacquer", "d", ""],
  ["Laila", "r", "300;400;500;600;700"],
  ["Lakki Reddy", "h", ""],
  ["Lalezar", "s", ""],
  ["Lancelot", "d", ""],
  ["Langar", "d", ""],
  ["Lateef", "r", "200;300;400;500;600;700;800"],
  ["Lato", "s", "100;300;400;700;900"],
  ["Lavishly Yours", "h", ""],
  ["League Gothic", "s", ""],
  ["League Script", "h", ""],
  ["League Spartan", "s", "100..900"],
  ["Leckerli One", "h", ""],
  ["Ledger", "r", ""],
  ["Lekton", "m", "400;700"],
  ["Lemon", "d", ""],
  ["Lemonada", "d", "300..700"],
  ["Lexend", "s", "100..900"],
  ["Lexend Deca", "s", "100..900"],
  ["Lexend Exa", "s", "100..900"],
  ["Lexend Giga", "s", "100..900"],
  ["Lexend Mega", "s", "100..900"],
  ["Lexend Peta", "s", "100..900"],
  ["Lexend Tera", "s", "100..900"],
  ["Lexend Zetta", "s", "100..900"],
  ["Libertinus Keyboard", "d", ""],
  ["Libertinus Math", "d", ""],
  ["Libertinus Mono", "m", ""],
  ["Libertinus Sans", "s", "400;700"],
  ["Libertinus Serif", "r", "400;600;700"],
  ["Libertinus Serif Display", "d", ""],
  ["Libre Barcode 128", "d", ""],
  ["Libre Barcode 128 Text", "d", ""],
  ["Libre Barcode 39", "d", ""],
  ["Libre Barcode 39 Extended", "d", ""],
  ["Libre Barcode 39 Extended Text", "d", ""],
  ["Libre Barcode 39 Text", "d", ""],
  ["Libre Barcode EAN13 Text", "d", ""],
  ["Libre Baskerville", "r", "400..700"],
  ["Libre Bodoni", "r", "400..700"],
  ["Libre Caslon Condensed", "r", "400..700"],
  ["Libre Caslon Display", "r", ""],
  ["Libre Caslon Text", "r", "400;700"],
  ["Libre Franklin", "s", "100..900"],
  ["Licorice", "h", ""],
  ["Life Savers", "d", "400;700;800"],
  ["Lilex", "m", "100..700"],
  ["Lilita One", "d", ""],
  ["Lily Script One", "d", ""],
  ["Limelight", "d", ""],
  ["Linden Hill", "r", ""],
  ["LINE Seed JP", "s", "100;400;700;800"],
  ["Linefont", "d", "4..1000"],
  ["Lisu Bosa", "r", "200;300;400;500;600;700;800;900"],
  ["Liter", "s", ""],
  ["Literata", "r", "200..900"],
  ["Liu Jian Mao Cao", "h", ""],
  ["Livvic", "s", "100;200;300;400;500;600;700;900"],
  ["Lobster", "d", ""],
  ["Lobster Two", "d", "400;700"],
  ["Londrina Outline", "d", ""],
  ["Londrina Shadow", "d", ""],
  ["Londrina Sketch", "d", ""],
  ["Londrina Solid", "d", "100;300;400;900"],
  ["Long Cang", "h", ""],
  ["Lora", "r", "400..700"],
  ["Love Light", "h", ""],
  ["Love Ya Like A Sister", "d", ""],
  ["Loved by the King", "h", ""],
  ["Lovers Quarrel", "h", ""],
  ["Luckiest Guy", "d", ""],
  ["Lugrasimo", "h", ""],
  ["Lumanosimo", "h", ""],
  ["Lunasima", "s", "400;700"],
  ["Lusitana", "r", "400;700"],
  ["Lustria", "r", ""],
  ["Luxurious Roman", "d", ""],
  ["Luxurious Script", "h", ""],
  ["LXGW Marker Gothic", "s", ""],
  ["LXGW WenKai Mono TC", "m", "300;400;700"],
  ["LXGW WenKai TC", "h", "300;400;700"],
  ["M PLUS 1", "s", "100..900"],
  ["M PLUS 1 Code", "m", "100..700"],
  ["M PLUS 1p", "s", "100;300;400;500;700;800;900"],
  ["M PLUS 2", "s", "100..900"],
  ["M PLUS Code Latin", "s", "100..700"],
  ["M PLUS Rounded 1c", "s", "100;300;400;500;700;800;900"],
  ["M PLUS U", "s", "100..900"],
  ["Ma Shan Zheng", "h", ""],
  ["Macondo", "d", ""],
  ["Macondo Swash Caps", "d", ""],
  ["Mada", "s", "200..900"],
  ["Madimi One", "s", ""],
  ["Magra", "s", "400;700"],
  ["Maiden Orange", "r", ""],
  ["Maitree", "r", "200;300;400;500;600;700"],
  ["Major Mono Display", "m", ""],
  ["Mako", "s", ""],
  ["Mali", "h", "200;300;400;500;600;700"],
  ["Mallanna", "s", ""],
  ["Maname", "r", ""],
  ["Mandali", "s", ""],
  ["Manjari", "s", "100;400;700"],
  ["Manrope", "s", "200..800"],
  ["Mansalva", "h", ""],
  ["Manuale", "r", "300..800"],
  ["Manufacturing Consent", "d", ""],
  ["Marcellus", "r", ""],
  ["Marcellus SC", "r", ""],
  ["Marck Script", "h", ""],
  ["Margarine", "d", ""],
  ["Marhey", "d", "300..700"],
  ["Markazi Text", "r", "400..700"],
  ["Marko One", "r", ""],
  ["Marmelad", "s", ""],
  ["Martel", "r", "200;300;400;600;700;800;900"],
  ["Martel Sans", "s", "200;300;400;600;700;800;900"],
  ["Martian Mono", "m", "100..800"],
  ["Marvel", "s", "400;700"],
  ["Matangi", "s", "300..900"],
  ["Mate", "r", ""],
  ["Mate SC", "r", ""],
  ["Matemasie", "s", ""],
  ["Maven Pro", "s", "400..900"],
  ["McLaren", "d", ""],
  ["Mea Culpa", "h", ""],
  ["Meddon", "h", ""],
  ["MedievalSharp", "d", ""],
  ["Medula One", "d", ""],
  ["Meera Inimai", "s", ""],
  ["Megrim", "d", ""],
  ["Meie Script", "h", ""],
  ["Menbere", "s", "100..700"],
  ["Meow Script", "h", ""],
  ["Merienda", "h", "300..900"],
  ["Merriweather", "r", "300..900"],
  ["Merriweather Sans", "s", "300..800"],
  ["Metal", "d", ""],
  ["Metal Mania", "d", ""],
  ["Metamorphous", "d", ""],
  ["Metrophobic", "s", ""],
  ["Michroma", "s", ""],
  ["Micro 5", "d", ""],
  ["Micro 5 Charted", "d", ""],
  ["Milonga", "d", ""],
  ["Miltonian", "d", ""],
  ["Miltonian Tattoo", "d", ""],
  ["Mina", "s", "400;700"],
  ["Mingzat", "s", ""],
  ["Miniver", "d", ""],
  ["Miranda Sans", "s", "400..700"],
  ["Miriam Libre", "s", "400..700"],
  ["Mirza", "r", "400;500;600;700"],
  ["Miss Fajardose", "h", ""],
  ["Mitr", "s", "200;300;400;500;600;700"],
  ["Mochiy Pop One", "s", ""],
  ["Mochiy Pop P One", "s", ""],
  ["Modak", "d", ""],
  ["Modern Antiqua", "d", ""],
  ["Moderustic", "s", "300..800"],
  ["Mogra", "d", ""],
  ["Mohave", "s", "300..700"],
  ["Moirai One", "d", ""],
  ["Molengo", "s", ""],
  ["Molle", "h", ""],
  ["Momo Signature", "s", ""],
  ["Momo Trust Display", "s", ""],
  ["Momo Trust Sans", "s", "200..800"],
  ["Mona Sans", "s", "200..900"],
  ["Monda", "s", "400..700"],
  ["Monofett", "m", ""],
  ["Monomakh", "d", ""],
  ["Monomaniac One", "s", ""],
  ["Monoton", "d", ""],
  ["Monsieur La Doulaise", "h", ""],
  ["Montaga", "r", ""],
  ["Montagu Slab", "r", "100..700"],
  ["MonteCarlo", "h", ""],
  ["Montenegrin Gothic One", "r", ""],
  ["Montez", "h", ""],
  ["Montserrat", "s", "100..900"],
  ["Montserrat Alternates", "s", "100;200;300;400;500;600;700;800;900"],
  ["Montserrat Underline", "s", "100..900"],
  ["Moo Lah Lah", "d", ""],
  ["Mooli", "s", ""],
  ["Moon Dance", "h", ""],
  ["Moul", "d", ""],
  ["Moulpali", "s", ""],
  ["Mountains of Christmas", "d", "400;700"],
  ["Mouse Memoirs", "s", ""],
  ["Mozilla Headline", "s", "200..700"],
  ["Mozilla Text", "s", "200..700"],
  ["Mr Bedfort", "h", ""],
  ["Mr Dafoe", "h", ""],
  ["Mr De Haviland", "h", ""],
  ["Mrs Saint Delafield", "h", ""],
  ["Mrs Sheppards", "h", ""],
  ["Ms Madi", "h", ""],
  ["Mukta", "s", "200;300;400;500;600;700;800"],
  ["Mukta Mahee", "s", "200;300;400;500;600;700;800"],
  ["Mukta Malar", "s", "200;300;400;500;600;700;800"],
  ["Mukta Vaani", "s", "200;300;400;500;600;700;800"],
  ["Mulish", "s", "200..1000"],
  ["Murecho", "s", "100..900"],
  ["MuseoModerno", "d", "100..900"],
  ["My Soul", "h", ""],
  ["Mynerve", "h", ""],
  ["Mystery Quest", "d", ""],
  ["Nabla", "d", ""],
  ["Namdhinggo", "r", "400;500;600;700;800"],
  ["Nanum Brush Script", "h", ""],
  ["Nanum Gothic", "s", "400;700;800"],
  ["Nanum Gothic Coding", "h", "400;700"],
  ["Nanum Myeongjo", "r", "400;700;800"],
  ["Nanum Pen Script", "h", ""],
  ["Narnoor", "s", "400;500;600;700;800"],
  ["Nata Sans", "s", "100..900"],
  ["National Park", "s", "200..800"],
  ["Neonderthaw", "h", ""],
  ["Nerko One", "h", ""],
  ["Neucha", "h", ""],
  ["Neuton", "r", "200;300;400;700;800"],
  ["New Amsterdam", "s", ""],
  ["New Rocker", "d", ""],
  ["New Tegomin", "r", ""],
  ["News Cycle", "s", "400;700"],
  ["Newsreader", "r", "200..800"],
  ["Niconne", "h", ""],
  ["Niramit", "s", "200;300;400;500;600;700"],
  ["Nixie One", "d", ""],
  ["Nobile", "s", "400;500;700"],
  ["Nokora", "s", "100..900"],
  ["Norican", "h", ""],
  ["Nosifer", "d", ""],
  ["Notable", "s", ""],
  ["Nothing You Could Do", "h", ""],
  ["Noticia Text", "r", "400;700"],
  ["Noto Color Emoji", "s", ""],
  ["Noto Emoji", "s", "300..700"],
  ["Noto Kufi Arabic", "s", "100..900"],
  ["Noto Music", "s", ""],
  ["Noto Naskh Arabic", "r", "400..700"],
  ["Noto Nastaliq Urdu", "r", "400..700"],
  ["Noto Rashi Hebrew", "r", "100..900"],
  ["Noto Sans", "s", "100..900"],
  ["Noto Sans Adlam", "s", "400..700"],
  ["Noto Sans Adlam Unjoined", "s", "400..700"],
  ["Noto Sans Anatolian Hieroglyphs", "s", ""],
  ["Noto Sans Arabic", "s", "100..900"],
  ["Noto Sans Armenian", "s", "100..900"],
  ["Noto Sans Avestan", "s", ""],
  ["Noto Sans Balinese", "s", "400..700"],
  ["Noto Sans Bamum", "s", "400..700"],
  ["Noto Sans Bassa Vah", "s", "400..700"],
  ["Noto Sans Batak", "s", ""],
  ["Noto Sans Bengali", "s", "100..900"],
  ["Noto Sans Bhaiksuki", "s", ""],
  ["Noto Sans Brahmi", "s", ""],
  ["Noto Sans Buginese", "s", ""],
  ["Noto Sans Buhid", "s", ""],
  ["Noto Sans Canadian Aboriginal", "s", "100..900"],
  ["Noto Sans Carian", "s", ""],
  ["Noto Sans Caucasian Albanian", "s", ""],
  ["Noto Sans Chakma", "s", ""],
  ["Noto Sans Cham", "s", "100..900"],
  ["Noto Sans Cherokee", "s", "100..900"],
  ["Noto Sans Chorasmian", "s", ""],
  ["Noto Sans Coptic", "s", ""],
  ["Noto Sans Cuneiform", "s", ""],
  ["Noto Sans Cypriot", "s", ""],
  ["Noto Sans Cypro Minoan", "s", ""],
  ["Noto Sans Deseret", "s", ""],
  ["Noto Sans Devanagari", "s", "100..900"],
  ["Noto Sans Display", "s", "100..900"],
  ["Noto Sans Duployan", "s", "400;700"],
  ["Noto Sans Egyptian Hieroglyphs", "s", ""],
  ["Noto Sans Elbasan", "s", ""],
  ["Noto Sans Elymaic", "s", ""],
  ["Noto Sans Ethiopic", "s", "100..900"],
  ["Noto Sans Georgian", "s", "100..900"],
  ["Noto Sans Glagolitic", "s", ""],
  ["Noto Sans Gothic", "s", ""],
  ["Noto Sans Grantha", "s", ""],
  ["Noto Sans Gujarati", "s", "100..900"],
  ["Noto Sans Gunjala Gondi", "s", "400..700"],
  ["Noto Sans Gurmukhi", "s", "100..900"],
  ["Noto Sans Hanifi Rohingya", "s", "400..700"],
  ["Noto Sans Hanunoo", "s", ""],
  ["Noto Sans Hatran", "s", ""],
  ["Noto Sans Hebrew", "s", "100..900"],
  ["Noto Sans HK", "s", "100..900"],
  ["Noto Sans Imperial Aramaic", "s", ""],
  ["Noto Sans Indic Siyaq Numbers", "s", ""],
  ["Noto Sans Inscriptional Pahlavi", "s", ""],
  ["Noto Sans Inscriptional Parthian", "s", ""],
  ["Noto Sans Javanese", "s", "400..700"],
  ["Noto Sans JP", "s", "100..900"],
  ["Noto Sans Kaithi", "s", ""],
  ["Noto Sans Kannada", "s", "100..900"],
  ["Noto Sans Kawi", "s", "400..700"],
  ["Noto Sans Kayah Li", "s", "400..700"],
  ["Noto Sans Kharoshthi", "s", ""],
  ["Noto Sans Khmer", "s", "100..900"],
  ["Noto Sans Khojki", "s", ""],
  ["Noto Sans Khudawadi", "s", ""],
  ["Noto Sans KR", "s", "100..900"],
  ["Noto Sans Lao", "s", "100..900"],
  ["Noto Sans Lao Looped", "s", "100..900"],
  ["Noto Sans Lepcha", "s", ""],
  ["Noto Sans Limbu", "s", ""],
  ["Noto Sans Linear A", "s", ""],
  ["Noto Sans Linear B", "s", ""],
  ["Noto Sans Lisu", "s", "400..700"],
  ["Noto Sans Lycian", "s", ""],
  ["Noto Sans Lydian", "s", ""],
  ["Noto Sans Mahajani", "s", ""],
  ["Noto Sans Malayalam", "s", "100..900"],
  ["Noto Sans Mandaic", "s", ""],
  ["Noto Sans Manichaean", "s", ""],
  ["Noto Sans Marchen", "s", ""],
  ["Noto Sans Masaram Gondi", "s", ""],
  ["Noto Sans Math", "s", ""],
  ["Noto Sans Mayan Numerals", "s", ""],
  ["Noto Sans Medefaidrin", "s", "400..700"],
  ["Noto Sans Meetei Mayek", "s", "100..900"],
  ["Noto Sans Mende Kikakui", "s", ""],
  ["Noto Sans Meroitic", "s", ""],
  ["Noto Sans Miao", "s", ""],
  ["Noto Sans Modi", "s", ""],
  ["Noto Sans Mongolian", "s", ""],
  ["Noto Sans Mono", "s", "100..900"],
  ["Noto Sans Mro", "s", ""],
  ["Noto Sans Multani", "s", ""],
  ["Noto Sans Myanmar", "s", "100..900"],
  ["Noto Sans Nabataean", "s", ""],
  ["Noto Sans Nag Mundari", "s", "400..700"],
  ["Noto Sans Nandinagari", "s", ""],
  ["Noto Sans New Tai Lue", "s", "400..700"],
  ["Noto Sans Newa", "s", ""],
  ["Noto Sans NKo", "s", ""],
  ["Noto Sans NKo Unjoined", "s", "400..700"],
  ["Noto Sans Nushu", "s", ""],
  ["Noto Sans Ogham", "s", ""],
  ["Noto Sans Ol Chiki", "s", "400..700"],
  ["Noto Sans Old Hungarian", "s", ""],
  ["Noto Sans Old Italic", "s", ""],
  ["Noto Sans Old North Arabian", "s", ""],
  ["Noto Sans Old Permic", "s", ""],
  ["Noto Sans Old Persian", "s", ""],
  ["Noto Sans Old Sogdian", "s", ""],
  ["Noto Sans Old South Arabian", "s", ""],
  ["Noto Sans Old Turkic", "s", ""],
  ["Noto Sans Oriya", "s", "100..900"],
  ["Noto Sans Osage", "s", ""],
  ["Noto Sans Osmanya", "s", ""],
  ["Noto Sans Pahawh Hmong", "s", ""],
  ["Noto Sans Palmyrene", "s", ""],
  ["Noto Sans Pau Cin Hau", "s", ""],
  ["Noto Sans PhagsPa", "s", ""],
  ["Noto Sans Phoenician", "s", ""],
  ["Noto Sans Psalter Pahlavi", "s", ""],
  ["Noto Sans Rejang", "s", ""],
  ["Noto Sans Runic", "s", ""],
  ["Noto Sans Samaritan", "s", ""],
  ["Noto Sans Saurashtra", "s", ""],
  ["Noto Sans SC", "s", "100..900"],
  ["Noto Sans Sharada", "s", ""],
  ["Noto Sans Shavian", "s", ""],
  ["Noto Sans Siddham", "s", ""],
  ["Noto Sans SignWriting", "s", ""],
  ["Noto Sans Sinhala", "s", "100..900"],
  ["Noto Sans Sogdian", "s", ""],
  ["Noto Sans Sora Sompeng", "s", "400..700"],
  ["Noto Sans Soyombo", "s", ""],
  ["Noto Sans Sundanese", "s", "400..700"],
  ["Noto Sans Sunuwar", "s", ""],
  ["Noto Sans Syloti Nagri", "s", ""],
  ["Noto Sans Symbols", "s", "100..900"],
  ["Noto Sans Symbols 2", "s", ""],
  ["Noto Sans Syriac", "s", "100..900"],
  ["Noto Sans Syriac Eastern", "s", "100..900"],
  ["Noto Sans Syriac Western", "s", "100..900"],
  ["Noto Sans Tagalog", "s", ""],
  ["Noto Sans Tagbanwa", "s", ""],
  ["Noto Sans Tai Le", "s", ""],
  ["Noto Sans Tai Tham", "s", "400..700"],
  ["Noto Sans Tai Viet", "s", ""],
  ["Noto Sans Takri", "s", ""],
  ["Noto Sans Tamil", "s", "100..900"],
  ["Noto Sans Tamil Supplement", "s", ""],
  ["Noto Sans Tangsa", "s", "400..700"],
  ["Noto Sans TC", "s", "100..900"],
  ["Noto Sans Telugu", "s", "100..900"],
  ["Noto Sans Thaana", "s", "100..900"],
  ["Noto Sans Thai", "s", "100..900"],
  ["Noto Sans Thai Looped", "s", "100..900"],
  ["Noto Sans Tifinagh", "s", ""],
  ["Noto Sans Tirhuta", "s", ""],
  ["Noto Sans Ugaritic", "s", ""],
  ["Noto Sans Vai", "s", ""],
  ["Noto Sans Vithkuqi", "s", "400..700"],
  ["Noto Sans Wancho", "s", ""],
  ["Noto Sans Warang Citi", "s", ""],
  ["Noto Sans Yi", "s", ""],
  ["Noto Sans Zanabazar Square", "s", ""],
  ["Noto Serif", "r", "100..900"],
  ["Noto Serif Ahom", "r", ""],
  ["Noto Serif Armenian", "r", "100..900"],
  ["Noto Serif Balinese", "r", ""],
  ["Noto Serif Bengali", "r", "100..900"],
  ["Noto Serif Devanagari", "r", "100..900"],
  ["Noto Serif Display", "r", "100..900"],
  ["Noto Serif Dives Akuru", "r", ""],
  ["Noto Serif Dogra", "r", ""],
  ["Noto Serif Ethiopic", "r", "100..900"],
  ["Noto Serif Georgian", "r", "100..900"],
  ["Noto Serif Grantha", "r", ""],
  ["Noto Serif Gujarati", "r", "100..900"],
  ["Noto Serif Gurmukhi", "r", "100..900"],
  ["Noto Serif Hebrew", "r", "100..900"],
  ["Noto Serif Hentaigana", "r", "200..900"],
  ["Noto Serif HK", "r", "200..900"],
  ["Noto Serif JP", "r", "200..900"],
  ["Noto Serif Kannada", "r", "100..900"],
  ["Noto Serif Khitan Small Script", "r", ""],
  ["Noto Serif Khmer", "r", "100..900"],
  ["Noto Serif Khojki", "r", "400..700"],
  ["Noto Serif KR", "r", "200..900"],
  ["Noto Serif Lao", "r", "100..900"],
  ["Noto Serif Makasar", "r", ""],
  ["Noto Serif Malayalam", "r", "100..900"],
  ["Noto Serif Myanmar", "r", "100;200;300;400;500;600;700;800;900"],
  ["Noto Serif NP Hmong", "r", "400..700"],
  ["Noto Serif Old Uyghur", "r", ""],
  ["Noto Serif Oriya", "r", "400..700"],
  ["Noto Serif Ottoman Siyaq", "r", ""],
  ["Noto Serif SC", "r", "200..900"],
  ["Noto Serif Sinhala", "r", "100..900"],
  ["Noto Serif Tamil", "r", "100..900"],
  ["Noto Serif Tangut", "r", ""],
  ["Noto Serif TC", "r", "200..900"],
  ["Noto Serif Telugu", "r", "100..900"],
  ["Noto Serif Thai", "r", "100..900"],
  ["Noto Serif Tibetan", "r", "100..900"],
  ["Noto Serif Todhri", "r", ""],
  ["Noto Serif Toto", "r", "400..700"],
  ["Noto Serif Vithkuqi", "r", "400..700"],
  ["Noto Serif Yezidi", "r", "400..700"],
  ["Noto Traditional Nushu", "s", "300..700"],
  ["Noto Znamenny Musical Notation", "s", ""],
  ["Nova Cut", "d", ""],
  ["Nova Flat", "d", ""],
  ["Nova Mono", "m", ""],
  ["Nova Oval", "d", ""],
  ["Nova Round", "d", ""],
  ["Nova Script", "d", ""],
  ["Nova Slim", "d", ""],
  ["Nova Square", "d", ""],
  ["NTR", "s", ""],
  ["Numans", "s", ""],
  ["Nunito", "s", "200..1000"],
  ["Nunito Sans", "s", "200..1000"],
  ["Nuosu SIL", "s", ""],
  ["Odibee Sans", "d", ""],
  ["Odor Mean Chey", "r", ""],
  ["Offside", "d", ""],
  ["Oi", "d", ""],
  ["Ojuju", "s", "200..800"],
  ["Old Standard TT", "r", "400;700"],
  ["Oldenburg", "d", ""],
  ["Ole", "h", ""],
  ["Oleo Script", "d", "400;700"],
  ["Oleo Script Swash Caps", "d", "400;700"],
  ["Onest", "s", "100..900"],
  ["Oooh Baby", "h", ""],
  ["Open Sans", "s", "300..800"],
  ["Oranienbaum", "r", ""],
  ["Orbit", "s", ""],
  ["Orbitron", "s", "400..900"],
  ["Oregano", "d", ""],
  ["Orelega One", "d", ""],
  ["Orienta", "s", ""],
  ["Original Surfer", "d", ""],
  ["Oswald", "s", "200..700"],
  ["Outfit", "s", "100..900"],
  ["Over the Rainbow", "h", ""],
  ["Overlock", "d", "400;700;900"],
  ["Overlock SC", "d", ""],
  ["Overpass", "s", "100..900"],
  ["Overpass Mono", "m", "300..700"],
  ["Ovo", "r", ""],
  ["Oxanium", "d", "200..800"],
  ["Oxygen", "s", "300;400;700"],
  ["Oxygen Mono", "m", ""],
  ["Pacifico", "h", ""],
  ["Padauk", "s", "400;700"],
  ["Padyakke Expanded One", "r", ""],
  ["Palanquin", "s", "100;200;300;400;500;600;700"],
  ["Palanquin Dark", "s", "400;500;600;700"],
  ["Palette Mosaic", "d", ""],
  ["Pangolin", "h", ""],
  ["Paprika", "d", ""],
  ["Parastoo", "r", "400..700"],
  ["Parisienne", "h", ""],
  ["Parkinsans", "s", "300..800"],
  ["Passero One", "d", ""],
  ["Passion One", "d", "400;700;900"],
  ["Passions Conflict", "h", ""],
  ["Pathway Extreme", "s", "100..900"],
  ["Pathway Gothic One", "s", ""],
  ["Patrick Hand", "h", ""],
  ["Patrick Hand SC", "h", ""],
  ["Pattaya", "s", ""],
  ["Patua One", "d", ""],
  ["Pavanam", "s", ""],
  ["Paytone One", "s", ""],
  ["Peddana", "r", ""],
  ["Peralta", "r", ""],
  ["Permanent Marker", "h", ""],
  ["Petemoss", "h", ""],
  ["Petit Formal Script", "h", ""],
  ["Petrona", "r", "100..900"],
  ["Phetsarath", "s", "400;700"],
  ["Philosopher", "s", "400;700"],
  ["Phudu", "d", "300..900"],
  ["Piazzolla", "r", "100..900"],
  ["Piedra", "d", ""],
  ["Pinyon Script", "h", ""],
  ["Pirata One", "d", ""],
  ["Pixelify Sans", "d", "400..700"],
  ["Plaster", "d", ""],
  ["Platypi", "r", "300..800"],
  ["Play", "s", "400;700"],
  ["Playball", "d", ""],
  ["Playfair", "r", "300..900"],
  ["Playfair Display", "r", "400..900"],
  ["Playfair Display SC", "r", "400;700;900"],
  ["Playpen Sans", "h", "100..800"],
  ["Playpen Sans Arabic", "h", "100..800"],
  ["Playpen Sans Deva", "h", "100..800"],
  ["Playpen Sans Hebrew", "h", "100..800"],
  ["Playpen Sans Thai", "h", "100..800"],
  ["Playwrite AR", "h", "100..400"],
  ["Playwrite AR Guides", "h", ""],
  ["Playwrite AT", "h", "100..400"],
  ["Playwrite AT Guides", "h", ""],
  ["Playwrite AU NSW", "h", "100..400"],
  ["Playwrite AU NSW Guides", "h", ""],
  ["Playwrite AU QLD", "h", "100..400"],
  ["Playwrite AU QLD Guides", "h", ""],
  ["Playwrite AU SA", "h", "100..400"],
  ["Playwrite AU SA Guides", "h", ""],
  ["Playwrite AU TAS", "h", "100..400"],
  ["Playwrite AU TAS Guides", "h", ""],
  ["Playwrite AU VIC", "h", "100..400"],
  ["Playwrite AU VIC Guides", "h", ""],
  ["Playwrite BE VLG", "h", "100..400"],
  ["Playwrite BE VLG Guides", "h", ""],
  ["Playwrite BE WAL", "h", "100..400"],
  ["Playwrite BE WAL Guides", "h", ""],
  ["Playwrite BR", "h", "100..400"],
  ["Playwrite BR Guides", "h", ""],
  ["Playwrite CA", "h", "100..400"],
  ["Playwrite CA Guides", "h", ""],
  ["Playwrite CL", "h", "100..400"],
  ["Playwrite CL Guides", "h", ""],
  ["Playwrite CO", "h", "100..400"],
  ["Playwrite CO Guides", "h", ""],
  ["Playwrite CU", "h", "100..400"],
  ["Playwrite CU Guides", "h", ""],
  ["Playwrite CZ", "h", "100..400"],
  ["Playwrite CZ Guides", "h", ""],
  ["Playwrite DE Grund", "h", "100..400"],
  ["Playwrite DE Grund Guides", "h", ""],
  ["Playwrite DE LA", "h", "100..400"],
  ["Playwrite DE LA Guides", "h", ""],
  ["Playwrite DE SAS", "h", "100..400"],
  ["Playwrite DE SAS Guides", "h", ""],
  ["Playwrite DE VA", "h", "100..400"],
  ["Playwrite DE VA Guides", "h", ""],
  ["Playwrite DK Loopet", "h", "100..400"],
  ["Playwrite DK Loopet Guides", "h", ""],
  ["Playwrite DK Uloopet", "h", "100..400"],
  ["Playwrite DK Uloopet Guides", "h", ""],
  ["Playwrite ES", "h", "100..400"],
  ["Playwrite ES Deco", "h", "100..400"],
  ["Playwrite ES Deco Guides", "h", ""],
  ["Playwrite ES Guides", "h", ""],
  ["Playwrite FR Moderne", "h", "100..400"],
  ["Playwrite FR Moderne Guides", "h", ""],
  ["Playwrite FR Trad", "h", "100..400"],
  ["Playwrite FR Trad Guides", "h", ""],
  ["Playwrite GB J", "h", "100..400"],
  ["Playwrite GB J Guides", "h", ""],
  ["Playwrite GB S", "h", "100..400"],
  ["Playwrite GB S Guides", "h", ""],
  ["Playwrite HR", "h", "100..400"],
  ["Playwrite HR Guides", "h", ""],
  ["Playwrite HR Lijeva", "h", "100..400"],
  ["Playwrite HR Lijeva Guides", "h", ""],
  ["Playwrite HU", "h", "100..400"],
  ["Playwrite HU Guides", "h", ""],
  ["Playwrite ID", "h", "100..400"],
  ["Playwrite ID Guides", "h", ""],
  ["Playwrite IE", "h", "100..400"],
  ["Playwrite IE Guides", "h", ""],
  ["Playwrite IN", "h", "100..400"],
  ["Playwrite IN Guides", "h", ""],
  ["Playwrite IS", "h", "100..400"],
  ["Playwrite IS Guides", "h", ""],
  ["Playwrite IT Moderna", "h", "100..400"],
  ["Playwrite IT Moderna Guides", "h", ""],
  ["Playwrite IT Trad", "h", "100..400"],
  ["Playwrite IT Trad Guides", "h", ""],
  ["Playwrite MX", "h", "100..400"],
  ["Playwrite MX Guides", "h", ""],
  ["Playwrite NG Modern", "h", "100..400"],
  ["Playwrite NG Modern Guides", "h", ""],
  ["Playwrite NL", "h", "100..400"],
  ["Playwrite NL Guides", "h", ""],
  ["Playwrite NO", "h", "100..400"],
  ["Playwrite NO Guides", "h", ""],
  ["Playwrite NZ", "h", "100..400"],
  ["Playwrite NZ Basic", "h", "100..400"],
  ["Playwrite NZ Basic Guides", "h", ""],
  ["Playwrite NZ Guides", "h", ""],
  ["Playwrite PE", "h", "100..400"],
  ["Playwrite PE Guides", "h", ""],
  ["Playwrite PL", "h", "100..400"],
  ["Playwrite PL Guides", "h", ""],
  ["Playwrite PT", "h", "100..400"],
  ["Playwrite PT Guides", "h", ""],
  ["Playwrite RO", "h", "100..400"],
  ["Playwrite RO Guides", "h", ""],
  ["Playwrite SK", "h", "100..400"],
  ["Playwrite SK Guides", "h", ""],
  ["Playwrite TZ", "h", "100..400"],
  ["Playwrite TZ Guides", "h", ""],
  ["Playwrite US Modern", "h", "100..400"],
  ["Playwrite US Modern Guides", "h", ""],
  ["Playwrite US Trad", "h", "100..400"],
  ["Playwrite US Trad Guides", "h", ""],
  ["Playwrite VN", "h", "100..400"],
  ["Playwrite VN Guides", "h", ""],
  ["Playwrite ZA", "h", "100..400"],
  ["Playwrite ZA Guides", "h", ""],
  ["Pliant", "s", "100..900"],
  ["Plus Jakarta Sans", "s", "200..800"],
  ["Pochaevsk", "d", ""],
  ["Podkova", "r", "400..800"],
  ["Poetsen One", "d", ""],
  ["Poiret One", "d", ""],
  ["Poller One", "d", ""],
  ["Poltawski Nowy", "r", "400..700"],
  ["Poly", "r", ""],
  ["Pompiere", "d", ""],
  ["Ponnala", "d", ""],
  ["Ponomar", "d", ""],
  ["Pontano Sans", "s", "300..700"],
  ["Poor Story", "d", ""],
  ["Poppins", "s", "100;200;300;400;500;600;700;800;900"],
  ["Port Lligat Sans", "s", ""],
  ["Port Lligat Slab", "r", ""],
  ["Potta One", "d", ""],
  ["Pragati Narrow", "s", "400;700"],
  ["Praise", "h", ""],
  ["Prata", "r", ""],
  ["Preahvihear", "s", ""],
  ["Press Start 2P", "d", ""],
  ["Pridi", "r", "200;300;400;500;600;700"],
  ["Princess Sofia", "h", ""],
  ["Prociono", "r", ""],
  ["Prompt", "s", "100;200;300;400;500;600;700;800;900"],
  ["Prosto One", "d", ""],
  ["Protest Guerrilla", "d", ""],
  ["Protest Revolution", "d", ""],
  ["Protest Riot", "d", ""],
  ["Protest Strike", "d", ""],
  ["Proza Libre", "s", "400;500;600;700;800"],
  ["PT Mono", "m", ""],
  ["PT Sans", "s", "400;700"],
  ["PT Sans Caption", "s", "400;700"],
  ["PT Sans Narrow", "s", "400;700"],
  ["PT Serif", "r", "400;700"],
  ["PT Serif Caption", "r", ""],
  ["Public Sans", "s", "100..900"],
  ["Puppies Play", "h", ""],
  ["Puritan", "s", "400;700"],
  ["Purple Purse", "d", ""],
  ["Qahiri", "s", ""],
  ["Quando", "r", ""],
  ["Quantico", "s", "400;700"],
  ["Quattrocento", "r", "400;700"],
  ["Quattrocento Sans", "s", "400;700"],
  ["Questrial", "s", ""],
  ["Quicksand", "s", "300..700"],
  ["Quintessential", "h", ""],
  ["Qwigley", "h", ""],
  ["Qwitcher Grypen", "h", "400;700"],
  ["Racing Sans One", "d", ""],
  ["Radio Canada", "s", "300..700"],
  ["Radio Canada Big", "s", "400..700"],
  ["Radley", "r", ""],
  ["Rajdhani", "s", "300;400;500;600;700"],
  ["Rakkas", "d", ""],
  ["Raleway", "s", "100..900"],
  ["Raleway Dots", "d", ""],
  ["Ramabhadra", "s", ""],
  ["Ramaraja", "r", ""],
  ["Rambla", "s", "400;700"],
  ["Rammetto One", "d", ""],
  ["Rampart One", "d", ""],
  ["Ramsina", "r", ""],
  ["Ranchers", "d", ""],
  ["Rancho", "h", ""],
  ["Ranga", "d", "400;700"],
  ["Rasa", "r", "300..700"],
  ["Rationale", "s", ""],
  ["Ravi Prakash", "d", ""],
  ["Readex Pro", "s", "160..700"],
  ["Recursive", "s", "300..1000"],
  ["Red Hat Display", "s", "300..900"],
  ["Red Hat Mono", "m", "300..700"],
  ["Red Hat Text", "s", "300..700"],
  ["Red Rose", "d", "300..700"],
  ["Redacted", "d", ""],
  ["Redacted Script", "d", "300;400;700"],
  ["Reddit Mono", "m", "200..900"],
  ["Reddit Sans", "s", "200..900"],
  ["Reddit Sans Condensed", "s", "200..900"],
  ["Redressed", "h", ""],
  ["Reem Kufi", "s", "400..700"],
  ["Reem Kufi Fun", "s", "400..700"],
  ["Reem Kufi Ink", "s", ""],
  ["Reenie Beanie", "h", ""],
  ["Reggae One", "d", ""],
  ["REM", "s", "100..900"],
  ["Rethink Sans", "s", "400..800"],
  ["Revalia", "d", ""],
  ["Rhodium Libre", "r", ""],
  ["Ribeye", "d", ""],
  ["Ribeye Marrow", "d", ""],
  ["Righteous", "d", ""],
  ["Risque", "d", ""],
  ["Road Rage", "d", ""],
  ["Roboto", "s", "100..900"],
  ["Roboto Condensed", "s", "100..900"],
  ["Roboto Flex", "s", "100..1000"],
  ["Roboto Mono", "m", "100..700"],
  ["Roboto Serif", "r", "100..900"],
  ["Roboto Slab", "r", "100..900"],
  ["Rochester", "h", ""],
  ["Rock 3D", "d", ""],
  ["Rock Salt", "h", ""],
  ["RocknRoll One", "s", ""],
  ["Rokkitt", "r", "100..900"],
  ["Romanesco", "h", ""],
  ["Ropa Sans", "s", ""],
  ["Rosario", "s", "300..700"],
  ["Rosarivo", "r", ""],
  ["Rouge Script", "h", ""],
  ["Rowdies", "d", "300;400;700"],
  ["Rozha One", "r", ""],
  ["Rubik", "s", "300..900"],
  ["Rubik 80s Fade", "d", ""],
  ["Rubik Beastly", "d", ""],
  ["Rubik Broken Fax", "d", ""],
  ["Rubik Bubbles", "d", ""],
  ["Rubik Burned", "d", ""],
  ["Rubik Dirt", "d", ""],
  ["Rubik Distressed", "d", ""],
  ["Rubik Doodle Shadow", "d", ""],
  ["Rubik Doodle Triangles", "d", ""],
  ["Rubik Gemstones", "d", ""],
  ["Rubik Glitch", "d", ""],
  ["Rubik Glitch Pop", "d", ""],
  ["Rubik Iso", "d", ""],
  ["Rubik Lines", "d", ""],
  ["Rubik Maps", "d", ""],
  ["Rubik Marker Hatch", "d", ""],
  ["Rubik Maze", "d", ""],
  ["Rubik Microbe", "d", ""],
  ["Rubik Mono One", "s", ""],
  ["Rubik Moonrocks", "d", ""],
  ["Rubik Pixels", "d", ""],
  ["Rubik Puddles", "d", ""],
  ["Rubik Scribble", "d", ""],
  ["Rubik Spray Paint", "d", ""],
  ["Rubik Storm", "d", ""],
  ["Rubik Vinyl", "d", ""],
  ["Rubik Wet Paint", "d", ""],
  ["Ruda", "s", "400..900"],
  ["Rufina", "r", "400;700"],
  ["Ruge Boogie", "h", ""],
  ["Ruluko", "s", ""],
  ["Rum Raisin", "s", ""],
  ["Ruslan Display", "d", ""],
  ["Russo One", "s", ""],
  ["Ruthie", "h", ""],
  ["Ruwudu", "r", "400;500;600;700"],
  ["Rye", "d", ""],
  ["Sacramento", "h", ""],
  ["Sahitya", "r", "400;700"],
  ["Sail", "d", ""],
  ["Saira", "s", "100..900"],
  ["Saira Condensed", "s", "100;200;300;400;500;600;700;800;900"],
  ["Saira Extra Condensed", "s", "100;200;300;400;500;600;700;800;900"],
  ["Saira Semi Condensed", "s", "100;200;300;400;500;600;700;800;900"],
  ["Saira Stencil", "d", "100..900"],
  ["Salsa", "d", ""],
  ["Sanchez", "r", ""],
  ["Sancreek", "d", ""],
  ["Sankofa Display", "s", ""],
  ["Sansation", "s", "300;400;700"],
  ["Sansita", "s", "400;700;800;900"],
  ["Sansita Swashed", "d", "300..900"],
  ["Sarabun", "s", "100;200;300;400;500;600;700;800"],
  ["Sarala", "s", "400;700"],
  ["Sarina", "d", ""],
  ["Sarpanch", "s", "400;500;600;700;800;900"],
  ["Sassy Frass", "h", ""],
  ["Satisfy", "h", ""],
  ["Savate", "s", "200..900"],
  ["Sawarabi Gothic", "s", ""],
  ["Sawarabi Mincho", "r", ""],
  ["Scada", "s", "400;700"],
  ["Scheherazade New", "r", "400;500;600;700"],
  ["Schibsted Grotesk", "s", "400..900"],
  ["Schoolbell", "h", ""],
  ["Science Gothic", "s", "100..900"],
  ["Scope One", "r", ""],
  ["Scoutie Sans", "s", "200..800"],
  ["Seaweed Script", "d", ""],
  ["Secular One", "s", ""],
  ["Sedan", "r", ""],
  ["Sedan SC", "r", ""],
  ["Sedgwick Ave", "h", ""],
  ["Sedgwick Ave Display", "h", ""],
  ["Sekuya", "d", ""],
  ["Sen", "s", "400..800"],
  ["Send Flowers", "h", ""],
  ["Sevillana", "d", ""],
  ["Seymour One", "s", ""],
  ["Shadows Into Light", "h", ""],
  ["Shadows Into Light Two", "h", ""],
  ["Shafarik", "d", ""],
  ["Shalimar", "h", ""],
  ["Shantell Sans", "d", "300..800"],
  ["Shanti", "s", ""],
  ["Share", "s", "400;700"],
  ["Share Tech", "s", ""],
  ["Share Tech Mono", "m", ""],
  ["Shippori Antique", "s", ""],
  ["Shippori Antique B1", "s", ""],
  ["Shippori Mincho", "r", "400;500;600;700;800"],
  ["Shippori Mincho B1", "r", "400;500;600;700;800"],
  ["Shizuru", "d", ""],
  ["Shojumaru", "d", ""],
  ["Short Stack", "h", ""],
  ["Shrikhand", "d", ""],
  ["Siemreap", "s", ""],
  ["Sigmar", "d", ""],
  ["Sigmar One", "d", ""],
  ["Signika", "s", "300..700"],
  ["Signika Negative", "s", "300..700"],
  ["Silkscreen", "d", "400;700"],
  ["Simonetta", "d", "400;900"],
  ["Single Day", "d", ""],
  ["Sintony", "s", "400;700"],
  ["Sirin Stencil", "d", ""],
  ["Sirivennela", "s", ""],
  ["Six Caps", "s", ""],
  ["Sixtyfour", "m", ""],
  ["Sixtyfour Convergence", "m", ""],
  ["Skranji", "d", "400;700"],
  ["Slabo 13px", "r", ""],
  ["Slabo 27px", "r", ""],
  ["Slackey", "d", ""],
  ["Slackside One", "h", ""],
  ["Smokum", "d", ""],
  ["Smooch", "h", ""],
  ["Smooch Sans", "s", "100..900"],
  ["Smythe", "d", ""],
  ["SN Pro", "s", "200..900"],
  ["Sniglet", "d", "400;800"],
  ["Snippet", "s", ""],
  ["Snowburst One", "d", ""],
  ["Sofadi One", "d", ""],
  ["Sofia", "h", ""],
  ["Sofia Sans", "s", "1..1000"],
  ["Sofia Sans Condensed", "s", "1..1000"],
  ["Sofia Sans Extra Condensed", "s", "1..1000"],
  ["Sofia Sans Semi Condensed", "s", "1..1000"],
  ["Solitreo", "h", ""],
  ["Solway", "r", "300;400;500;700;800"],
  ["Sometype Mono", "m", "400..700"],
  ["Song Myung", "r", ""],
  ["Sono", "s", "200..800"],
  ["Sonsie One", "d", ""],
  ["Sora", "s", "100..800"],
  ["Sorts Mill Goudy", "r", ""],
  ["Sour Gummy", "s", "100..900"],
  ["Source Code Pro", "m", "200..900"],
  ["Source Sans 3", "s", "200..900"],
  ["Source Serif 4", "r", "200..900"],
  ["Space Grotesk", "s", "300..700"],
  ["Space Mono", "m", "400;700"],
  ["Special Elite", "d", ""],
  ["Special Gothic", "s", "400..700"],
  ["Special Gothic Condensed One", "s", ""],
  ["Special Gothic Expanded One", "s", ""],
  ["Spectral", "r", "200;300;400;500;600;700;800"],
  ["Spectral SC", "r", "200;300;400;500;600;700;800"],
  ["Spicy Rice", "d", ""],
  ["Spinnaker", "s", ""],
  ["Spirax", "d", ""],
  ["Splash", "h", ""],
  ["Spline Sans", "s", "300..700"],
  ["Spline Sans Mono", "m", "300..700"],
  ["Squada One", "d", ""],
  ["Square Peg", "h", ""],
  ["Sree Krushnadevaraya", "r", ""],
  ["Sriracha", "h", ""],
  ["Srisakdi", "d", "400;700"],
  ["Staatliches", "d", ""],
  ["Stack Sans Headline", "s", "200..700"],
  ["Stack Sans Notch", "s", "200..700"],
  ["Stack Sans Text", "s", "200..700"],
  ["Stalemate", "h", ""],
  ["Stalinist One", "d", ""],
  ["Stardos Stencil", "d", "400;700"],
  ["Stick", "s", ""],
  ["Stick No Bills", "s", "200..800"],
  ["Stint Ultra Condensed", "r", ""],
  ["Stint Ultra Expanded", "r", ""],
  ["STIX Two Math", "r", ""],
  ["STIX Two Text", "r", "400..700"],
  ["Stoke", "r", "300;400"],
  ["Story Script", "s", ""],
  ["Strait", "s", ""],
  ["Strichpunkt Sans", "s", "400..900"],
  ["Style Script", "h", ""],
  ["Stylish", "s", ""],
  ["Sue Ellen Francisco", "h", ""],
  ["Suez One", "r", ""],
  ["Sulphur Point", "s", "300;400;700"],
  ["Sumana", "r", "400;700"],
  ["Sunflower", "s", "300;500;700"],
  ["Sunshiney", "h", ""],
  ["Supermercado One", "d", ""],
  ["Sura", "r", "400;700"],
  ["Suranna", "r", ""],
  ["Suravaram", "r", ""],
  ["SUSE", "s", "100..900"],
  ["SUSE Mono", "s", "100..800"],
  ["Suwannaphum", "r", "100;300;400;700;900"],
  ["Swanky and Moo Moo", "h", ""],
  ["Syncopate", "s", "400;700"],
  ["Syne", "s", "400..800"],
  ["Syne Mono", "m", ""],
  ["Syne Tactile", "d", ""],
  ["Tac One", "s", ""],
  ["Tagesschrift", "d", ""],
  ["Tai Heritage Pro", "r", "400;700"],
  ["Tajawal", "s", "200;300;400;500;700;800;900"],
  ["Tangerine", "h", "400;700"],
  ["Tapestry", "h", ""],
  ["Taprom", "d", ""],
  ["TASA Explorer", "s", "400..800"],
  ["TASA Orbiter", "s", "400..800"],
  ["Tauri", "s", ""],
  ["Taviraj", "r", "100;200;300;400;500;600;700;800;900"],
  ["Teachers", "s", "400..800"],
  ["Teko", "s", "300..700"],
  ["Tektur", "d", "400..900"],
  ["Telex", "s", ""],
  ["Tenali Ramakrishna", "s", ""],
  ["Tenor Sans", "s", ""],
  ["Text Me One", "s", ""],
  ["Texturina", "r", "100..900"],
  ["Thasadith", "s", "400;700"],
  ["The Girl Next Door", "h", ""],
  ["The Nautigal", "h", "400;700"],
  ["Tienne", "r", "400;700;900"],
  ["TikTok Sans", "s", "300..900"],
  ["Tillana", "d", "400;500;600;700;800"],
  ["Tilt Neon", "d", ""],
  ["Tilt Prism", "d", ""],
  ["Tilt Warp", "d", ""],
  ["Timmana", "s", ""],
  ["Tinos", "r", "400;700"],
  ["Tiny5", "s", ""],
  ["Tiro Bangla", "r", ""],
  ["Tiro Devanagari Hindi", "r", ""],
  ["Tiro Devanagari Marathi", "r", ""],
  ["Tiro Devanagari Sanskrit", "r", ""],
  ["Tiro Gurmukhi", "r", ""],
  ["Tiro Kannada", "r", ""],
  ["Tiro Tamil", "r", ""],
  ["Tiro Telugu", "r", ""],
  ["Tirra", "s", "400;500;600;700;800;900"],
  ["Titan One", "d", ""],
  ["Titillium Web", "s", "200;300;400;600;700;900"],
  ["Tomorrow", "s", "100;200;300;400;500;600;700;800;900"],
  ["Tourney", "d", "100..900"],
  ["Trade Winds", "d", ""],
  ["Train One", "d", ""],
  ["Triodion", "d", ""],
  ["Trirong", "r", "100;200;300;400;500;600;700;800;900"],
  ["Trispace", "s", "100..800"],
  ["Trocchi", "r", ""],
  ["Trochut", "d", "400;700"],
  ["Truculenta", "s", "100..900"],
  ["Trykker", "r", ""],
  ["Tsukimi Rounded", "s", "300;400;500;600;700"],
  ["Tuffy", "s", "400;700"],
  ["Tulpen One", "d", ""],
  ["Turret Road", "d", "200;300;400;500;700;800"],
  ["Twinkle Star", "h", ""],
  ["Ubuntu", "s", "300;400;500;700"],
  ["Ubuntu Condensed", "s", ""],
  ["Ubuntu Mono", "m", "400;700"],
  ["Ubuntu Sans", "s", "100..800"],
  ["Ubuntu Sans Mono", "m", "400..700"],
  ["Uchen", "r", ""],
  ["Ultra", "r", ""],
  ["Unbounded", "s", "200..900"],
  ["Uncial Antiqua", "d", ""],
  ["Underdog", "d", ""],
  ["Unica One", "d", ""],
  ["UnifrakturCook", "d", "700"],
  ["UnifrakturMaguntia", "d", ""],
  ["Unkempt", "d", "400;700"],
  ["Unlock", "d", ""],
  ["Unna", "r", "400;700"],
  ["UoqMunThenKhung", "r", ""],
  ["Updock", "h", ""],
  ["Urbanist", "s", "100..900"],
  ["Valley Sans", "s", "100..900"],
  ["Vampiro One", "d", ""],
  ["Varela", "s", ""],
  ["Varela Round", "s", ""],
  ["Varta", "s", "300..700"],
  ["Vast Shadow", "r", ""],
  ["Vazirmatn", "s", "100..900"],
  ["Vend Sans", "s", "300..700"],
  ["Vesper Libre", "r", "400;500;700;900"],
  ["Viaoda Libre", "d", ""],
  ["Vibes", "d", ""],
  ["Vibur", "h", ""],
  ["Victor Mono", "m", "100..700"],
  ["Vidaloka", "r", ""],
  ["Viga", "s", ""],
  ["Vina Sans", "d", ""],
  ["Voces", "s", ""],
  ["Volkhov", "r", "400;700"],
  ["Vollkorn", "r", "400..900"],
  ["Vollkorn SC", "r", "400;600;700;900"],
  ["Voltaire", "s", ""],
  ["VT323", "m", ""],
  ["Vujahday Script", "h", ""],
  ["Waiting for the Sunrise", "h", ""],
  ["Wallpoet", "d", ""],
  ["Walter Turncoat", "h", ""],
  ["Warnes", "d", ""],
  ["Water Brush", "h", ""],
  ["Waterfall", "h", ""],
  ["Wavefont", "d", "4..1000"],
  ["WDXL Lubrifont JP N", "s", ""],
  ["WDXL Lubrifont SC", "s", ""],
  ["WDXL Lubrifont TC", "s", ""],
  ["Wellfleet", "r", ""],
  ["Wendy One", "s", ""],
  ["Whisper", "h", ""],
  ["WindSong", "h", "400;500"],
  ["Winky Rough", "s", "300..900"],
  ["Winky Sans", "s", "300..900"],
  ["Wire One", "s", ""],
  ["Wittgenstein", "r", "400..900"],
  ["Wix Madefor Display", "s", "400..800"],
  ["Wix Madefor Text", "s", "400..800"],
  ["Work Sans", "s", "100..900"],
  ["Workbench", "m", ""],
  ["Xanh Mono", "m", ""],
  ["Yaldevi", "s", "200..700"],
  ["Yanone Kaffeesatz", "s", "200..700"],
  ["Yantramanav", "s", "100;300;400;500;700;900"],
  ["Yarndings 12", "d", ""],
  ["Yarndings 12 Charted", "d", ""],
  ["Yarndings 20", "d", ""],
  ["Yarndings 20 Charted", "d", ""],
  ["Yatra One", "d", ""],
  ["Yellowtail", "h", ""],
  ["Yeon Sung", "d", ""],
  ["Yeseva One", "d", ""],
  ["Yesteryear", "h", ""],
  ["Yomogi", "h", ""],
  ["Young Serif", "r", ""],
  ["Yrsa", "r", "300..700"],
  ["Ysabeau", "s", "1..1000"],
  ["Ysabeau Infant", "s", "1..1000"],
  ["Ysabeau Office", "s", "1..1000"],
  ["Ysabeau SC", "s", "1..1000"],
  ["Yuji Boku", "r", ""],
  ["Yuji Hentaigana Akari", "h", ""],
  ["Yuji Hentaigana Akebono", "h", ""],
  ["Yuji Mai", "r", ""],
  ["Yuji Syuku", "r", ""],
  ["Yusei Magic", "s", ""],
  ["Yuyu", "h", ""],
  ["Yuyu Short", "h", ""],
  ["Zain", "s", "200;300;400;700;800;900"],
  ["Zalando Sans", "s", "200..900"],
  ["Zalando Sans Expanded", "s", "200..900"],
  ["Zalando Sans SemiExpanded", "s", "200..900"],
  ["ZCOOL KuaiLe", "s", ""],
  ["ZCOOL QingKe HuangYou", "s", ""],
  ["ZCOOL XiaoWei", "s", ""],
  ["Zen Antique", "r", ""],
  ["Zen Antique Soft", "r", ""],
  ["Zen Dots", "d", ""],
  ["Zen Kaku Gothic Antique", "s", "300;400;500;700;900"],
  ["Zen Kaku Gothic New", "s", "300;400;500;700;900"],
  ["Zen Kurenaido", "s", ""],
  ["Zen Loop", "d", ""],
  ["Zen Maru Gothic", "s", "300;400;500;700;900"],
  ["Zen Old Mincho", "r", "400;500;600;700;900"],
  ["Zen Tokyo Zoo", "d", ""],
  ["Zeyada", "h", ""],
  ["Zhi Mang Xing", "h", ""],
  ["Zilla Slab", "r", "300;400;500;600;700"],
  ["Zilla Slab Highlight", "r", "400;700"],
];

const GENERIC: Record<GoogleFontEntry[1], string> = { s: 'sans-serif', r: 'serif', m: 'monospace', h: 'cursive', d: 'sans-serif' };

/** The CSS font stack for a catalogue family, e.g. "'Geist Mono', monospace". */
export function googleFontStack([family, category]: GoogleFontEntry): string {
  const name = /^[A-Za-z][A-Za-z-]*$/.test(family) ? family : `'${family}'`;
  return `${name}, ${GENERIC[category]}`;
}
